import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

/**
 * The app-wide "something went wrong" screen.
 *
 * Rendered from two places, because one boundary cannot cover both cases:
 * <Sentry.ErrorBoundary> in App catches anything thrown outside the router,
 * and RouteErrorBoundary catches route subtrees, which the data router keeps
 * to itself rather than rethrowing to an ancestor.
 */
const ErrorFallback = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      gap: 2,
      p: 3,
      textAlign: "center",
    }}
  >
    <Typography variant="h5">Something went wrong</Typography>
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
      }}
    >
      An unexpected error occurred. Please reload the page.
    </Typography>
    <Button variant="contained" onClick={() => window.location.reload()}>
      Reload
    </Button>
  </Box>
);

export default ErrorFallback;
